import React, {Component, useEffect, useState} from "react";
import KeyValue from '../_core/KeyValue'

import {Button, Form, Message, Segment} from "semantic-ui-react";
import {useNavigate, useParams} from "react-router";

export default function ContactDetail(props) {
    const [data, setData] = useState({
        contact: {
            steuerberater_kontonummer: ""
        },
        saved: false
    });
    let {contactId} = useParams()
    const navigate = useNavigate()

    const change = (e) => {
        let newState = data.contact;
        let value = e.target.value
        newState[e.target.name] = value
        setData({...data, contact: newState})

    }

    const update = (e) => {
        const {contact} = data
        const url = API_URL + '/api/private/tanker/v1/contacts/' + contact.id;

        const body = JSON.stringify({
            steuerberater_kontonummer: contact.steuerberater_kontonummer,
        })

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {
            method: 'PUT',
            headers: new Headers({'Authorization': `Bearer ${token}`}),
            body: body
        }).then(function (response) {
            if (response.status >= 400) {
                console.error("Response: ", response);
                throw new Error("Bad response from server");
            }
            setData({...data, saved: true})
        })
    }

    const fetchData = async () => {
        try {
            const url = API_URL + '/api/private/tanker/v1/contacts/' + contactId;

            const token = sessionStorage.token
            if (!(token && token.length > 0)) navigate('/login')

            fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function (data) {
                    setData({...data, contact: data});
                });
        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        document.title = 'Contacts'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const {contact, saved} = data
    return (
        <div>
            <h2>ContactDetail {contactId}</h2>
            <KeyValue pair={contact}/>
            <h3>Bearbeiten</h3>
            <Form>
                <Form.Field>
                    <Form.Input label="Steuerberater Kontonummer" placeholder="" name='steuerberater_kontonummer'
                                value={contact.steuerberater_kontonummer} onChange={change} required/>
                    <Button type="submit" primary onClick={update}> Speichern</Button>
                    <Button onClick={() => navigate(-1)}>Abbrechen</Button>
                </Form.Field>
            </Form>
            {saved == true && <Message
                success
                header='Steuerberater Kontonummer aktualisiert'
                content='Daten wurden gespeichert.'
            />}
        </div>
    )
}


